import rootInstance from "@/services/root.js";

export default function() {
	rootInstance.defaults.baseURL = process.env.MIX_TROPHIES_API_URL + "/api/v1";
	return rootInstance;
}
